import React from "react";
import { string } from "prop-types";
import RichText from "../../atoms/RichText";
import "./collection-summary.m.css";

const CollectionSummary = ({ title, summary, ...props }) => {
  return (
    <>
      {/* Title Section - Red background with white text */}
      <section styleName="title-section" {...props}>
        <p styleName="title">IMA {title === "Sessions" ? "Forum Exclusive Sessions" : title}</p>
      </section>

      {/* Summary Section - Light pink background */}
      <section styleName="summary-section">
        <p styleName="summary">
          <RichText content={summary} />
        </p>
      </section>
    </>
  );
};

CollectionSummary.propTypes = {
  title: string.isRequired,
  summary: string.isRequired
};

export default CollectionSummary;